import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-user-folder-icon',
  templateUrl: './files-user-folder.component.html'
})
export class FilesUserFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
